/**
 * Carte d'indicateur : un chiffre, ce qu'il désigne, d'où il vient.
 *
 * Chaque carte porte une couleur d'accent, choisie pour ce qu'elle dit et non
 * pour égayer : rouge sur une affaire chaude, vert sur ce qui est acquis,
 * orange sur ce qui reste à encaisser. Un coup d'œil suffit alors à repérer ce
 * qui demande une action.
 *
 * La couleur tient dans un liseré fin et dans le chiffre. Le reste — libellé,
 * précision, fond — demeure neutre : c'est ce qui empêche six cartes colorées
 * de devenir illisibles côte à côte.
 */
import React, { useState } from 'react';
import { C, E, RAYON, OMBRE, T, ACCENTS } from '../theme';

export default function Indicateur({ libelle, valeur, precision, onClick, accent, compact }) {
  const [survol, setSurvol] = useState(false);
  const cliquable = typeof onClick === 'function';
  const teinte = ACCENTS[accent] || ACCENTS.marine;

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setSurvol(true)}
      onMouseLeave={() => setSurvol(false)}
      style={{
        background: C.surface,
        border: `1px solid ${C.bordure}`,
        borderLeft: `3px solid ${teinte.trait}`,
        borderRadius: RAYON.lg,
        padding: compact ? `${E.md} ${E.lg}` : `${E.lg} ${E.lg}`,
        boxShadow: survol && cliquable ? OMBRE.carte : 'none',
        transform: survol && cliquable ? 'translateY(-1px)' : 'none',
        cursor: cliquable ? 'pointer' : 'default',
        transition: 'box-shadow 120ms ease, transform 120ms ease',
        display: 'flex', flexDirection: 'column', gap: '2px',
        minWidth: 0,
      }}
    >
      <div style={{ ...T.etiquette, color: C.texteMoyen, display: 'flex',
                    alignItems: 'center', gap: E.xs }} translate="no">
        {libelle}
        {cliquable && (
          <span style={{ color: teinte.trait, opacity: survol ? 1 : 0,
                         transition: 'opacity 120ms ease' }}>→</span>
        )}
      </div>
      <div style={{ ...T.chiffre, color: teinte.texte,
                    fontSize: compact ? '22px' : '26px' }}>
        {valeur}
      </div>
      {precision && (
        <div style={{ fontSize: '11.5px', color: C.texteFaible, lineHeight: 1.35 }} translate="no">
          {precision}
        </div>
      )}
    </div>
  );
}
